export type AddonServiceLike = {
  serviceId?: unknown;
  id?: unknown;
  total?: unknown;
  fixed?: unknown;
  rate?: unknown;
};

export function getAddonServiceId(s: AddonServiceLike): number | null {
  const v = (s as any)?.serviceId ?? (s as any)?.id;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export function getAddonServicePrice(s: AddonServiceLike): number {
  const candidates = [(s as any)?.total, (s as any)?.fixed, (s as any)?.rate];
  for (const v of candidates) {
    const n = Number(v);
    if (Number.isFinite(n) && n !== 0) return n;
  }
  const fallback = Number(candidates[0] ?? 0);
  return Number.isFinite(fallback) ? fallback : 0;
}

export function normalizeAddonServicesResponse(data: any): any[] {
  const list = data?.data || data?.services || data || [];
  return Array.isArray(list) ? list : [];
}

export function sumSelectedAddonServicesTotal(
  services: AddonServiceLike[] | undefined,
  selectedIds: Array<number | string> | undefined
): number {
  if (!Array.isArray(services) || !services.length) return 0;
  if (!Array.isArray(selectedIds) || !selectedIds.length) return 0;

  const set = new Set(selectedIds.map((x) => Number(x)).filter((n) => Number.isFinite(n)));
  let sum = 0;
  for (const s of services) {
    const id = getAddonServiceId(s);
    if (id === null || !set.has(id)) continue;
    sum += getAddonServicePrice(s);
  }
  return sum;
}

export function resolveSelectedAddonServices(
  equipFee: any,
  addonServices: AddonServiceLike[] | undefined,
  selectedServiceIds: number[],
): AddonServiceLike[] {
  if (!Array.isArray(selectedServiceIds) || selectedServiceIds.length === 0) return [];

  const idSet = new Set(
    selectedServiceIds.map((id) => Number(id)).filter((id) => Number.isFinite(id)),
  );

  const resolved = new Map<number, AddonServiceLike>();

  if (Array.isArray(equipFee?.services)) {
    for (const service of equipFee.services) {
      const id = getAddonServiceId(service);
      if (id !== null && idSet.has(id)) {
        resolved.set(id, service);
      }
    }
  }

  for (const service of addonServices || []) {
    const id = getAddonServiceId(service);
    if (id !== null && idSet.has(id) && !resolved.has(id)) {
      resolved.set(id, service);
    }
  }

  return selectedServiceIds
    .map((id) => resolved.get(Number(id)))
    .filter((service): service is AddonServiceLike => Boolean(service));
}

